import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { Field, FormikProps, useFormikContext } from 'formik'
import { CheckboxInput } from '../../../../../../../components/inputs/CheckboxInput'

interface Props {}

export const DemolitionTechnicalFormB1M: React.FC<Props> = (props) => {
  const formik = useFormikContext() as FormikProps<any>

  return (
    <FormSectionTwoColumns
      title="m) základní předpoklady pro odstranění stavby"
      subtitle="stanovení posloupnosti jednotlivých etap, časové údaje o průběhu prací, předpokládaný způsob odstranění staveb, věcné a časové vazby; podmiňující, vyvolané, související investice, odhad využitelných materiálů"
      sectionKey="b1m"
    >
      <>
        <div className="sm:col-span-6">
          <Field
            name="b1m.demolitionSequence"
            label="Posloupnost jednotlivých etap"
            component={RichTextInput}
            aiHint={
              'Stanovení posloupnosti jednotlivých etap odstranění stavby'
            }
          />
        </div>
        <div className="sm:col-span-6">
          <Field
            name="b1m.timeSchedule"
            label="Časové údaje o průběhu prací"
            component={RichTextInput}
            aiHint={
              'Časové údaje o průběhu prací při odstraňování stavby'
            }
          />
        </div>
        <div className="sm:col-span-6">
          <Field
            name="b1m.demolitionMethod"
            label="Předpokládaný způsob odstranění staveb"
            component={RichTextInput}
            aiHint={
              'Předpokládaný způsob odstranění staveb'
            }
          />
        </div>
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1m.hasDependencies"
            label="Věcné a časové vazby"
          />
        </div>
        {formik?.values.b1m?.hasDependencies && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b1m.dependencies"
              label=""
              component={RichTextInput}
              aiHint={
                'Věcné a časové vazby při odstraňování stavby'
              }
            />
          </div>
        )}

        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1m.hasRelatedInvestments"
            label="Podmiňující, vyvolané, související investice"
          />
        </div>
        {formik?.values.b1m?.hasRelatedInvestments && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b1m.relatedInvestments"
              label=""
              component={RichTextInput}
              aiHint={
                'Podmiňující, vyvolané a související investice při odstraňování stavby'
              }
            />
          </div>
        )}

        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1m.hasReusableMaterials"
            label="Odhad využitelných materiálů"
          />
        </div>
        {formik?.values.b1m?.hasReusableMaterials && (
          <div className="sm:col-span-6 pl-7">
            <Field
              name="b1m.reusableMaterials"
              label=""
              component={RichTextInput}
              aiHint={
                'Odhad využitelných materiálů z odstraňované stavby'
              }
            />
          </div>
        )}
      </>
    </FormSectionTwoColumns>
  )
}
